import { useAtomValue } from 'jotai';
import { Routes } from 'src/Routes.constants';
import { mapRSimFiltersToURLSearchParams } from '../Filters/SearchParams/constants/rsimSearchParams';
import { rsimFiltersAtom } from 'src/atoms/filters/rsim-products';

export const useRSimProductUrlFromFilters = () => {
  const filters = useAtomValue(rsimFiltersAtom);
  return `${Routes.productsRsim}?${mapRSimFiltersToURLSearchParams(filters)}`;
};
